import { render, staticRenderFns } from "./ObserverMode.vue?vue&type=template&id=51906876&scoped=true&"
import script from "./ObserverMode.vue?vue&type=script&lang=js&"
export * from "./ObserverMode.vue?vue&type=script&lang=js&"
import style0 from "./ObserverMode.vue?vue&type=style&index=0&id=51906876&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51906876",
  null
  
)

export default component.exports